import { AgGridReact } from 'ag-grid-react';
import classNames from 'classnames';
import { useEffect } from 'react';
import { ExtendedGridOptions } from '../../types';

import { ApLoaderDefault } from '@alixpartners/ui-components';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-enterprise';
import {
  DEFAULT_COL_DEF_CONTRACTS,
  GRID_FLOATING_FILTER_HEIGHT,
  GRID_HEADER_HEIGHT,
  SIDE_BAR_CONFIG,
} from '../../const';
import '../ag-theme-alpine.css';
import './ContractsGrid.css';
import { getGridRowId } from './ContractsGrid.utils';

export interface IProps {
  isColumnSelectionOpen: boolean;
  gridOptions: ExtendedGridOptions;
  loading?: boolean;
  dataSourceLoading?: boolean;
}

export const ContractsGrid = ({
  isColumnSelectionOpen,
  gridOptions,
  loading = false,
  dataSourceLoading,
}: IProps) => {
  const { ref } = gridOptions;

  const gridApi = ref?.current?.api;

  useEffect(() => {
    isColumnSelectionOpen
      ? gridApi?.openToolPanel('columns')
      : gridApi?.closeToolPanel();
  }, [gridApi, isColumnSelectionOpen]);

  useEffect(() => {
    if (!gridApi) return;
     if (!dataSourceLoading && !gridApi?.getRenderedNodes().length) {
      gridApi.showNoRowsOverlay();
    } else {
      gridApi.hideOverlay();
    }
  }, [gridApi, dataSourceLoading, gridOptions]);

  return (
    <div
      id="id-contracts-grid" // this is used for Batch Editor dialog
      className={classNames('contracts-tool-grid', 'ag-theme-alpine')}
    >
      <AgGridReact
        ref={ref}
        animateRows
        rowSelection="multiple"
        rowClass="contracts-tool-grid__row"
        rowModelType="serverSide"
        serverSideInfiniteScroll
        serverSideSortOnServer
        suppressRowClickSelection
        loadingOverlayComponent={ApLoaderDefault}
        overlayNoRowsTemplate='No results matching the search'
        defaultColDef={{
          ...DEFAULT_COL_DEF_CONTRACTS,
          // this will disable column checkboxes while running graphQL query
          lockVisible: dataSourceLoading,
        }}
        sideBar={SIDE_BAR_CONFIG}
        headerHeight={GRID_HEADER_HEIGHT}
        floatingFiltersHeight={GRID_FLOATING_FILTER_HEIGHT}
        getRowId={getGridRowId} // we have to set getRowId it to enable rows animations
        tooltipMouseTrack
        tooltipShowDelay={0.5}
        tooltipHideDelay={2000000000000000} // we need this to prevent built in tooltip auto hide after 20s
        {...gridOptions}
      />
    </div>
  );
};
